import * as React from 'react';
import { Heading, Selector, Separator, Spinner, Text } from 'telia-front-react';
import { TRANSLATIONS_APP_NAME } from '@telia-common-components/shared';
import TvChannelComparisonChannelsGrid from './TvChannelComparisonChannelsGrid';
const TvChannelComparisonModalContent = (props) => {
    var _a;
    if (!props.packageNames.length || !props.channelInclusions.length || !((_a = props.translations) === null || _a === void 0 ? void 0 : _a[TRANSLATIONS_APP_NAME])) {
        return (React.createElement(Text, { className: "text-center" },
            React.createElement(Spinner, null)));
    }
    const packageNameToOfferNameMap = {};
    props.packageNames.forEach((name, index) => (packageNameToOfferNameMap[name] = props.packagePrices[index]));
    const selectorItems = props.packageNames.map((packet) => ({
        id: packet,
        name: 'selectedPacket',
        label: `${props.translate(`tvcomparison.heading.package.${packageNameToOfferNameMap[packet].name}`)}`,
        value: packet
    }));
    const defaultSelectedPackage = props.packageNames.find((p) => p === props.defaultSelectedPackage) || null;
    const selectedPackage = props.selectedPackage || defaultSelectedPackage || selectorItems[0].value;
    const [showAllChannels, setShowAllChannels] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: "text-center" },
            React.createElement(Heading, { level: props.headingLevel || 2 }, props.headingText || props.translate('tvChannelComparison.heading')),
            React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
            React.createElement(Selector, { id: "channel-comparison-selected-package", items: selectorItems, value: selectedPackage, onChange: (value) => props.setSelectedPackage(value), label: `${props.translate('tvChannelComparison.selector.label')}`, hideLabel: true, align: "center" }),
            React.createElement("p", { className: "h4 text-bold" }, `${packageNameToOfferNameMap[selectedPackage].price} ${props.translate('tvcomparison.price.permonth')}`),
            React.createElement("p", null, props.translate('tvChannelComparison.price.description'))),
        React.createElement(Separator, { color: "invisible", spacing: "small" }),
        React.createElement(TvChannelComparisonChannelsGrid, { key: selectedPackage, channelInclusions: props.channelInclusions, selectedPackage: selectedPackage, translate: props.translate, showAllChannels: showAllChannels, setShowAllChannels: setShowAllChannels })));
};
export default TvChannelComparisonModalContent;
